import { AfterContentInit, AfterViewInit, Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { TeamsService } from '../services/teams.service';
import { Team, TeamAdapter } from '../models/team';
import { map, Observable, tap } from 'rxjs';
import { RouterModule, withDebugTracing } from '@angular/router';

import { IShape } from './interfaces/IShape';
import { ShapeBuilder } from './utils/shapeBuilder';
import { teamComplicatedSubsystem } from './shapes/team-complicated_subsystem';
import { teamUndefined } from './shapes/team-undefined';
import { After } from 'v8';
import { MapService } from '../services/map.service';

@Component({
  selector: 'app-map',
  standalone: true,
  imports: [RouterModule],
  templateUrl: './map.component.html',
  styleUrl: './map.component.scss'
})
export class MapComponent  implements OnInit {
  @ViewChild('svgGrid', { read: ElementRef })
  svgGrid!: ElementRef<SVGSVGElement>;
  
  public teams: Team[] = [];
  public shapes: IShape[] = [];
  public selectedShapes: IShape[] = [];
  public isDraggingShape = false;
  public draggingShape: IShape | null = null;
  

  constructor(
    private teamsService: TeamsService,
    private teamAdapter: TeamAdapter,
    private shapeBuilder: ShapeBuilder,
    private mapService: MapService,
  ) {}

  ngOnInit(): void {
    
      this.teamsService
      .getTeams()
      .pipe(
        map((data: any[]) => data.map((item) => this.teamAdapter.adapt(item))),
        tap((teams: Team[]) => {
          this.teams = teams;
        }),
        map((teams: Team[]) => teams.map((team) => this.shapeBuilder.buildTeamShape(team)))
      )
      .subscribe((shapes: IShape[]) => {
        this.shapes = shapes;
        this.spreadShapes();
      });

    // let shape = new teamComplicatedSubsystem();
    // this.shapes.push(shape);
    // let shape2 = new teamUndefined();
    // this.shapes.push(shape2);
  }

  spreadShapes() {
    const viewBoxList = this.svgGrid?.nativeElement?.getAttribute('viewBox')?.split(' ');

    if(!viewBoxList){
      return
    }
    const center_X = (parseInt(viewBoxList[2], 10)); 

    console.log("center_X : " + center_X);
    let offsetY= 20
    for (let i = 0; i < this.shapes.length; i++) {
      console.log("shape BEFORE spreading X Y : "+this.shapes[i].positionX, this.shapes[i].positionY);
      console.log("SHapes : " + JSON.stringify(this.shapes[i]));

      // TODO: Handle particular shape like polygon 
      this.shapes[i].positionX = center_X - this.shapes[i].width;
      this.shapes[i].positionY = offsetY;

      offsetY += this.shapes[i].height + 10;

      console.log("shape AFTER spreading X Y : "+this.shapes[i].positionX, this.shapes[i].positionY);
    }
  }

  saveMap() {
    this.mapService.saveMap(this.shapes);
  }

  round(v: number) {
    return Math.round(v / 10) * 10;
  }

  downHandleShape(pointerEvent: PointerEvent, Shape: IShape) {
    // this.isDraggingGrid = false;
    this.isDraggingShape = true;
    this.draggingShape = Shape;
    pointerEvent.preventDefault();
    console.log("click on shape : " + this.draggingShape);
  }

  @HostListener( 'document:pointerup', [ '$event' ] )
  public upHandle(event: PointerEvent) {
    // this.isDraggingGrid = false;
    this.isDraggingShape = false;
    // this.draggingShape = null;
  }

  @HostListener( 'document:pointermove', [ '$event' ] )
  public moveHandle(pointerEvent: PointerEvent){
    pointerEvent.preventDefault();
    pointerEvent.stopPropagation();

    //usefull for zoom
    // if (!this.isDraggingGrid && this.isDraggingNodeLayer) {
    if (this.isDraggingShape) {
      const viewBoxList = this.svgGrid?.nativeElement?.getAttribute('viewBox')?.split(' ');
      
      console.log("moving the shape : " + JSON.stringify(this.draggingShape));
      
      if (!viewBoxList) {
        console.error('viewBox not found');
        console.log(this.svgGrid?.nativeElement?.getAttribute('viewBox'));
        console.log('viewbox not found')
        return;
      }

        const aspX = (parseInt(viewBoxList[2], 10) / 1000);
        const aspY = (parseInt(viewBoxList[3], 10) / 1000);
      
      console.log("viewBoxList : " + viewBoxList)
      console.log("aspX, aspY : " + aspX, aspY);

      if(this.draggingShape){
      // move Shape
        if (pointerEvent.offsetX) {
            this.draggingShape.positionX = this.round((pointerEvent.offsetX * aspX) + parseInt(viewBoxList[0], 10)) ;
            this.draggingShape.positionY = this.round((pointerEvent.offsetY * aspY) + parseInt(viewBoxList[1], 10)) ;
            console.log("IF offsetX : "+pointerEvent.offsetX, pointerEvent.offsetY, aspX, aspY, this.draggingShape.positionX, this.draggingShape.positionY);
        } else {
          const { left, top } = (pointerEvent.srcElement as Element).getBoundingClientRect();
          this.draggingShape.positionX = pointerEvent.clientX - left + parseInt(viewBoxList[0], 10);
          this.draggingShape.positionY = pointerEvent.clientY - top + parseInt(viewBoxList[1], 10);
          console.log("ELSE  "+pointerEvent.clientX, pointerEvent.clientY, left, top, this.draggingShape.positionX, this.draggingShape.positionY);
        }
      }

    }
  }

  clickHandleShape(pointerEvent: MouseEvent, shape: IShape) {
    pointerEvent.preventDefault();
    pointerEvent.stopPropagation();

    if (!pointerEvent.shiftKey) {
      if (this.selectedShapes.length > 0){
        this.selectedShapes.forEach((selectedSVGLayer: IShape) => {
          selectedSVGLayer.isSelected = false;
          // selectedSVGLayer.shadowFilter = 'url(#shadow)';
        });
        this.selectedShapes = [];
      }
    }

    shape.isSelected = true;
    // shape.shadowFilter = 'url(#liftedShadow)';
    this.selectedShapes.push(shape);
    console.log("click on shape : " + JSON.stringify(shape));
    // this.translatePolygon(shape);
    // shape.positionX = 222;
    // shape.positionY = 111;
    console.log("set position of shape to : " + JSON.stringify(shape));
  }



}


